const API = "https://api.carbelim.io/api";

export default API;